class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );
    
    document.body.classList.add('overflow-hidden');
   //---------------Readmore Readless----------------
  //    setTimeout(() => {
  //   const containers = document.querySelectorAll('.free-item-readmore-readless');
        
  //       containers.forEach(container => {
  //           const readMoreBtns = container.querySelectorAll('.readmore-btn');
  //           const readLessBtns = container.querySelectorAll('.readless-btn');
  //           const content = container.querySelector('span');
            
  //           const fullHeight = content.scrollHeight + 'px';
  //           content.style.maxHeight = '0';

  //           readMoreBtns.forEach(btn => {
  //               btn.addEventListener('click', function(event) {
  //                   event.preventDefault();
  //                   container.classList.add('show');
  //                   content.style.maxHeight = fullHeight;
  //                   readMoreBtns.forEach(b => b.style.display = 'none');
  //                   readLessBtns.forEach(b => b.style.display = 'inline');
  //               });
  //           });

  //           readLessBtns.forEach(btn => {
  //               btn.addEventListener('click', function(event) {
  //                   event.preventDefault();
  //                   container.classList.remove('show');
  //                   content.style.maxHeight = '0';
  //                   readMoreBtns.forEach(b => b.style.display = 'inline');
  //                   readLessBtns.forEach(b => b.style.display = 'none');
  //               });
  //           });
  //       });
  // }, 400);

    function initializeReadMoreLess(container) {
    const readMoreBtns = container.querySelectorAll('.readmore-btn');
    const readLessBtns = container.querySelectorAll('.readless-btn');
    const content = container.querySelector('span');
    if (!content || readMoreBtns.length === 0 || readLessBtns.length === 0) return;
    const fullHeight = content.scrollHeight + 'px';
    content.style.maxHeight = '0';
    content.style.transition = 'max-height 0.3s ease';
    readLessBtns.forEach(b => b.style.display = 'none');
    readMoreBtns.forEach(b => b.style.display = 'inline');
    function showMore(event) {
        event.preventDefault();
        container.classList.add('show');
        content.style.maxHeight = fullHeight;
        readMoreBtns.forEach(b => b.style.display = 'none');
        readLessBtns.forEach(b => b.style.display = 'inline');
    }
    function showLess(event) {
        event.preventDefault();
        container.classList.remove('show');
        content.style.maxHeight = '0';
        readMoreBtns.forEach(b => b.style.display = 'inline');
        readLessBtns.forEach(b => b.style.display = 'none');
    }
    readMoreBtns.forEach(btn => {
        btn.removeEventListener('click', showMore);
        btn.addEventListener('click', showMore);
    });
    readLessBtns.forEach(btn => {
        btn.removeEventListener('click', showLess);
        btn.addEventListener('click', showLess);
    });
  }
  
  function setupAllContainers() {
      const containers = document.querySelectorAll('.free-item-readmore-readless');
      containers.forEach(container => initializeReadMoreLess(container));
  }
  setupAllContainers();
  const observer = new MutationObserver((mutations) => {
      mutations.forEach(mutation => {
          if (mutation.addedNodes.length) {
              mutation.addedNodes.forEach(node => {
                  if (node.nodeType === 1) { 
                      if (node.classList.contains('free-item-readmore-readless')) {
                          initializeReadMoreLess(node);
                      }
                      const containers = node.querySelectorAll('.free-item-readmore-readless');
                      containers.forEach(container => initializeReadMoreLess(container));
                  }
              });
          }
      });
  });
  observer.observe(document.body, {
      childList: true,
      subtree: true
  });
  function disconnectObserver() {
      observer.disconnect();
  }
//------------------------------- 
}

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });
    
    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
      this.onCartChange();
    });
  }
   onCartChange(cartState) {
     // setTimeout(function() {
       updateCart('change-drawer')
     // }, 2000)
    }
  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// ______________Readmore_______________


// ______________Readmore_______________